import createInitialValue from "../../../Utilities/InitialValuesSetup/createInitialValueNew";
import automaticValidationSchema from "../../../Utilities/ValidationSchemaSetup/automaticValidationSchemaNew";
import { reInitializeRelianceIPAInitialValues } from "./ReinitializeValuesHelper/reInitializeRelianceIPAInitialValues";

/**
 * Retrieves the form configuration details including initial values, validation schema, and steps.
 *
 * @param {object} formConfigJSON - The JSON object containing the form configuration.
 * @param {object} quickQuoteDetails - The details related to the quick quote.
 * @param {number} activeStep - The active step index.
 * @returns {object} An object containing the initial values, validation schema, and steps.
 */
export default function getFormConfig(
  formConfigJSON,
  quickQuoteDetails,
  activeStep
) {
  let initialValues;
  let validationSchema;
  const steps = [];
  const SchemaArray = [];

  if (Object.keys(formConfigJSON).length > 0) {
    // Create Initial Values
    initialValues = createInitialValue(formConfigJSON);

    // Reinitialize values
    if (formConfigJSON.productName === "Reliance IPA") {
      initialValues = reInitializeRelianceIPAInitialValues(
        initialValues,
        quickQuoteDetails
      );
    }

    console.log("initialValues", initialValues);
    // Create tabs
    formConfigJSON?.requestBody?.formFields?.fields.forEach((item) => {
      steps.push(item.label);

      let separateArray = [];
      separateArray.push(item);
      SchemaArray.push(separateArray);
    });

    validationSchema = automaticValidationSchema(SchemaArray[activeStep]);
  }

  return {
    initialValues,
    validationSchema,
    steps,
  };
}
